import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.auth.join');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-auth-join',
template: templateSource || '',
    styles: [``],
})
export class PortalAuthJoinComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    public form: any = {
        email: '',
        password: '',
        password_repeat: '',
        name: '',
        mobile: ''
    };

    public emailChecked = false;
    public pwError: string | null = null;
    public pwReError: string | null = null;

    constructor(@Inject( Service) public service: Service) { }

    async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, '/home');
        await this.service.render();
    }

    private showModal(message): Promise<boolean> {
        return this.modalMessage.open({ message });
    }

    onEmailChange() {
        this.emailChecked = false;
    }

    private emailValidator(email) {
        if (!email) return false;

        const re =
            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        return re.test(email.trim());
    }

    async checkEmail() {
        this.emailChecked = false;

        if (!this.emailValidator(this.form.email)) {
            await this.showModal('이메일 형식이 맞지 않습니다.');
            return;
        }

        const { code } = await wiz.call('check', { email: this.form.email });

        if (code === 409) {
            await this.showModal('이미 가입된 메일입니다.');
            return;
        }

        if (code !== 200) {
            await this.showModal('이메일 확인 중 오류가 발생했습니다.');
            return;
        }

        this.emailChecked = true;
        await this.service.render();
    }

    validatePassword() {
        this.pwError =
            !this.form.password || this.form.password.length < 8
                ? '비밀번호는 8자리 이상이어야 합니다'
                : null;
    }

    validatePasswordRepeat() {
        this.pwReError =
            this.form.password !== this.form.password_repeat
                ? '비밀번호가 일치하지 않습니다'
                : null;
    }

    formatMobile() {
        this.form.mobile = this.form.mobile.replace(/[^0-9]/g, '');
    }

    async join() {

        if (!this.emailValidator(this.form.email)) {
            await this.showModal('올바른 이메일 형식이 아닙니다.');
            return;
        }

        if (!this.emailChecked) {
            await this.showModal('이메일 중복 확인을 해주세요.');
            return;
        }

        if (this.pwError || this.pwReError) {
            await this.showModal('비밀번호를 확인하세요.');
            return;
        }

        const { code } = await wiz.call('join', this.form);

        if (code !== 200) {
            await this.showModal('회원가입에 실패하였습니다. 정보를 확인해주세요.');
            return;
        }

        await this.showModal('회원가입이 완료되었습니다.');
        await this.service.render();
    }
}

export default PortalAuthJoinComponent;